import { requestApi } from './Api';

export const downloadFile = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/filestack/download',
    params
  });

export const readFile = async (navigate, params, onError) =>
  requestApi({
    navigate,
    url: '/api/filestack/read',
    params,
    onError
  });

export const getSecurity = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/filestack/security',
    params
  });
};

export const getFileText = async ({ handle, navigate, signal }) => {
  const res = await requestApi({
    navigate,
    url: `/api/resources/images/${handle}`,
    method: 'get',
    responseType: 'text',
    returnRaw: true,
    signal
  });
  if (res?.status >= 400) throw new Error('Failed to load file');
  return typeof res?.data === 'string' ? res.data : '';
};

export const getFileStackUrl = async (navigate, params = {}) => {
  return requestApi({
    navigate,
    url: '/api/filestack/preview',
    params
  });
};
